module.exports = __webpack_public_path__ + "static/media/refresh-disabled.9e8520be.svg";